module.exports = "<div *ngIf=\"messageService.messages.length\">\n\n  <h2>Messages</h2>\n  <button class=\"clear\"\n          (click)=\"messageService.clear()\">clear</button>\n  <div *ngFor='let message of messageService.messages'> {{message}} </div>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/messages/messages.component.html
// module id = ./src/app/messages/messages.component.html
// module chunks = main